import { render, staticRenderFns } from "./LmButtonBuilderUi.vue?vue&type=template&id=5a4ae2af&"
import script from "./LmButtonBuilderUi.vue?vue&type=script&lang=js&"
export * from "./LmButtonBuilderUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports